import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import MoaStyledComponent from "../../Style/MoaStyled";
import Color from "../../Style/Color";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
var StyledComponent = styled(function (props) {
    return (_jsx("div", { id: props === null || props === void 0 ? void 0 : props.id, "data-current-value": props === null || props === void 0 ? void 0 : props.checked, children: _jsx(FormControlLabel, { label: props === null || props === void 0 ? void 0 : props.name, labelPlacement: props === null || props === void 0 ? void 0 : props.namePlacement, required: props === null || props === void 0 ? void 0 : props.required, onChange: props === null || props === void 0 ? void 0 : props.onChange, disabled: props === null || props === void 0 ? void 0 : props.disabled, "aria-label": "".concat(props === null || props === void 0 ? void 0 : props.ariaLabel, " FormControlLabel"), name: props === null || props === void 0 ? void 0 : props.name, checked: props === null || props === void 0 ? void 0 : props.checked, control: _jsx(Checkbox, { defaultChecked: props === null || props === void 0 ? void 0 : props.defaultChecked, indeterminate: props === null || props === void 0 ? void 0 : props.indeterminate, disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, inputRef: props === null || props === void 0 ? void 0 : props.inputRef, inputProps: {
                    "aria-label": "".concat((props === null || props === void 0 ? void 0 : props.name) || "", " ").concat(props === null || props === void 0 ? void 0 : props.ariaLabel),
                }, sx: {
                    ".MuiSvgIcon-root": {
                        fontSize: "1rem",
                    },
                    "&.Mui-checked": {
                        color: Color.primary.main,
                    },
                    "&.MuiCheckbox-indeterminate": {
                        color: Color.primary.main,
                    },
                    ":not(.Mui-checked)": {
                        ":not(.MuiCheckbox-indeterminate)": {
                            "&:hover": {
                                color: Color.component.gray_dark,
                            },
                            ":not(hover)": {
                                color: Color.component.gray,
                            },
                        },
                    },
                    "&.Mui-disabled": {
                        color: "".concat(Color.component.gray_light, "!important"),
                    },
                    margin: "0.25rem",
                    padding: 0,
                } }), sx: {
                m: 0,
                gap: "0.25rem",
                ".MuiTypography-root": {
                    color: "".concat(Color.text.secondary, "!important"),
                    "&.Mui-disabled": {
                        color: "".concat(Color.component.gray_light, "!important"),
                    },
                },
            } }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
